module.exports = __webpack_public_path__ + "static/solution-section-vm-tab-dc4b169f7aa8f65abd18a6eb5db8f3fe.webp";